import React, { useEffect } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom'; 
import './ConfirmationPage.css';
import { FaCheckCircle, FaDownload, FaCalendarAlt, FaArrowLeft } from 'react-icons/fa';

const ConfirmationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const booking = location.state?.booking;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Error State (Page Refresh)
  if (!booking) {
    return (
      <div className="confirmation-page">
        <div className="confirmation-container">
          <h1 className="confirmation-title error-title">Details Not Found</h1>
          <p className="confirmation-subtitle">
            This happens if the page is refreshed. Please check your email for the invoice.
          </p>
          <div className="confirmation-actions stack-mobile">
            <Link to="/" className="btn btn-primary">
               <FaArrowLeft /> Return to Homepage
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="confirmation-page">
      <div className="confirmation-container">
        
        <header className="conf-header no-print">
            <FaCheckCircle className="success-icon" />
            <h1 className="confirmation-title">Booking Confirmed!</h1>
            <p className="confirmation-subtitle">Thank you, <b>{booking.name}</b>. Your appointment receipt is below.</p>
        </header>

        {/* ELEGANT HTML RECEIPT CARD */}
        <div className="receipt-card" id="receipt">
          <div className="receipt-brand">Haus Of Aura</div>
          <div className="receipt-label">Official Receipt</div>
          
          <div className="receipt-grid">
            <div className="receipt-item">
              <span>Client</span>
              <p>{booking.name}</p>
            </div>
            <div className="receipt-item">
              <span>Booking ID</span>
              <p>#HA-{booking._id.slice(-6).toUpperCase()}</p>
            </div>
            <div className="receipt-item">
              <span>Date & Time</span>
              <p>{new Date(booking.date).toDateString()} at {booking.timeSlot}</p>
            </div>
            <div className="receipt-item">
              <span>Location</span>
              <p>{booking.address || "Studio Walk-in"}</p>
            </div>
          </div>

          <div className="receipt-table">
            <div className="table-header">
              <span>Service</span>
              <span>Price</span>
            </div>
            <div className="table-row">
              <span className="service-name">{booking.specificService}</span>
              <span className="service-price">{booking.price}</span>
            </div>
            <div className="table-total">
              <span>Total Paid/Due</span>
              <span>{booking.price}</span>
            </div>
          </div>

          <div className="receipt-footer">
            <p>Please present this receipt or your Booking ID upon arrival.</p>
            <p className="footer-copyright">© {new Date().getFullYear()} Haus Of Aura Artistry</p>
          </div>
        </div>

        {/* ACTION BUTTONS */}
        <div className="confirmation-actions stack-mobile no-print">
          <button className="btn btn-primary" onClick={handlePrint}>
             <FaDownload /> Save / Print Receipt
          </button>

          <Link to="/" className="btn btn-secondary">
            <FaCalendarAlt /> Book Another
          </Link>
        </div>

      </div>
    </div>
  );
};

export default ConfirmationPage;